// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__qOFgf","dadosUsuario":"OptionSelect_dadosUsuario__YyGCp","focado":"OptionSelect_focado__CUQB1"};